module.exports = __webpack_public_path__ + "static/about_system_ankieta-97d46c1aa5b6093377257ad709bedcff.png";